import * as React from 'react';
import { DesignSection } from '../../types';
import { BaseButton } from '@routes/event/create/components/BaseButton';

interface Props {
  section: DesignSection;
  value: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  displayString?: string;
  ariaLabel?: string;
}

export const SelectableOption: React.SFC<Props & React.HtmlHTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  value,
  section,
  displayString,
  ariaLabel,
  ...props
}) => {
  return (
    <BaseButton
      onClick={onClick}
      data-section={section}
      data-displaystring={displayString ? displayString : undefined}
      aria-label={ariaLabel ? ariaLabel : undefined}
      title={ariaLabel ? ariaLabel : undefined}
      value={value}
      {...props}
    />
  );
};
